import React from 'react';
import { AnimatedSpinnerFullScreen } from '../../../../components/common/ui-widgets/animated-spinner-full-screen';

export const DashboardFallback: React.FC = (): React.ReactElement => {
    return <AnimatedSpinnerFullScreen />;
};
